import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Ana Sayfa', path: '/' },
    { name: 'Hizmetlerimiz', path: '/hizmetler' },
    { name: 'Halı Türleri', path: '/hali-turleri' },
    { name: 'Blog', path: '/blog' },
    { name: 'Hakkımızda', path: '/hakkimizda' },
    { name: 'İletişim', path: '/iletisim' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="/images/duru-logo.png" 
              alt="Duru Halı Yıkama Logo" 
              className="h-14 w-auto object-contain"
            />
            <div className="flex flex-col">
              <span className="text-xl md:text-2xl font-bold text-gray-900">Duru Halı Yıkama</span>
              <span className="text-xs md:text-sm text-teal-600 font-medium">{companyInfo.tagline}</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => window.scrollTo(0, 0)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? 'bg-teal-50 text-teal-600'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </nav>

          {/* Phone Button */}
          <div className="hidden lg:flex items-center space-x-3">
            <a href={`tel:${companyInfo.phones[0]}`}>
              <Button className="bg-teal-600 hover:bg-teal-700 text-white">
                <Phone className="w-4 h-4 mr-2" />
                {companyInfo.phones[0]}
              </Button>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden py-4 border-t">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                onClick={() => { setIsMenuOpen(false); window.scrollTo(0, 0); }}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  isActive(item.path)
                    ? 'bg-teal-50 text-teal-600'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <a
              href={`tel:${companyInfo.phones[0]}`}
              className="block mt-4"
              onClick={() => setIsMenuOpen(false)}
            >
              <Button className="w-full bg-teal-600 hover:bg-teal-700 text-white">
                <Phone className="w-4 h-4 mr-2" />
                Hemen Ara
              </Button>
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
